module.exports = __webpack_public_path__ + "static/reisbanner-57562e25f7d74b108671783fac88f23c.png";